import axios from 'axios';

const zrusKorporatniAkciApi = (id: number) => {
    return axios({
        method: 'POST',
        url: `SRD/${id}/Zrus`
    });
};

export const zrusKorporatniAkciZaznamApi = (id: number, idZaznam: number) => {
    return axios({
        method: 'POST',
        url: `SRD/${id}/Zrusakci/${idZaznam}`
    });
};
export default zrusKorporatniAkciApi;
